import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

async function VendasPorCupom(salesData) {

  function converterDataIsoParaBr(dataIso) {
    const data = new Date(dataIso);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const empresa = await getEmpresa();
  salesData = Array.isArray(salesData) ? salesData : [];

  // 🔹 Agrupamento por cupom
  const groupedSalesData = salesData.reduce((acc, sale) => {
    if (!sale || !sale.DOCUMENTO) return acc;

    if (!acc[sale.DOCUMENTO]) {
      acc[sale.DOCUMENTO] = {
        itens: [],
        venda: sale.COD_VENDA ?? 'N/A',
        data: converterDataIsoParaBr(sale.DATA) ?? 'N/A',
        numccf: sale.NUMCCF ?? 'N/A',
        caixa: sale.CAIXA ?? 'N/A',
        totalVenda: 0,
        totalCompra: 0,
        totalDesconto: 0,
        totalLucro: 0
      };
    }

    acc[sale.DOCUMENTO].itens.push(sale);

    acc[sale.DOCUMENTO].totalVenda += Number(sale.TOTAL_ITEM ?? 0);
    acc[sale.DOCUMENTO].totalCompra += Number(sale.COMPRA ?? 0);
    acc[sale.DOCUMENTO].totalDesconto += Number(sale.DESCONTO_ITEM ?? 0);

    return acc;
  }, {});

  Object.values(groupedSalesData).forEach(v => {
    v.totalLucro = v.totalVenda - v.totalDesconto - v.totalCompra;
  });

  // 🔹 Totais gerais
  const totalVendaGeral = Object.values(groupedSalesData).reduce((s, v) => s + v.totalVenda, 0);
  const totalCompraGeral = Object.values(groupedSalesData).reduce((s, v) => s + v.totalCompra, 0);
  const totalDescontoGeral = Object.values(groupedSalesData).reduce((s, v) => s + v.totalDesconto, 0);
  const totalLucroGeral = totalVendaGeral - totalDescontoGeral - totalCompraGeral;

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [20, 60, 20, 40],
    header: headerEmpresa(empresa),

    content: [
      {
        text: 'Relatório de Vendas por Cupom',
        style: 'header',
        margin: [0, 10, 0, 20]
      }
    ],

    styles: {
      header: { fontSize: 18, bold: true, alignment: 'center' },
      blockHeader: { fontSize: 12, bold: true, margin: [0, 10, 0, 5], fillColor: '#f0f0f0' },
      tableHeader: { fontSize: 9, bold: true, fillColor: '#f0f0f0' },
      tableBody: { fontSize: 8 },
      summary: { fontSize: 9, bold: true, alignment: 'center' },
      resumoTitulo: { fontSize: 10, bold: true, alignment: 'center', fillColor: '#f0f0f0' }
    }
  };

  // 🔹 Conteúdo por cupom
  Object.values(groupedSalesData).forEach((vendaData) => {

    const body = [
      [
        { text: 'Código', style: 'tableHeader', colSpan: 2 }, {},
        { text: 'Descrição', style: 'tableHeader', colSpan: 4 }, {}, {}, {},
        { text: 'Item', style: 'tableHeader' },
        { text: 'Qtd', style: 'tableHeader', colSpan: 2 }, {}
      ]
    ];

    vendaData.itens.forEach((sale) => {
      const totalItem = Number(sale.TOTAL_ITEM ?? 0);
      const compra = Number(sale.COMPRA ?? 0);
      const desconto = Number(sale.DESCONTO_ITEM ?? 0);
      const lucro = totalItem - desconto - compra;

      body.push([
        { text: sale.COD_PRODUTO ?? '', colSpan: 2 }, {},
        { text: sale.DESCRICAO ?? '', colSpan: 4 }, {}, {}, {},
        { text: sale.ITEM ?? '' },
        { text: Number(sale.QTD ?? 0).toFixed(3), colSpan: 2 }, {}
      ]);

      body.push([
        { text: 'Venda', bold: true },
        { text: totalItem.toFixed(2), alignment: 'right' },
        { text: 'Desc.', bold: true },
        { text: desconto.toFixed(2), alignment: 'right' },
        { text: 'Compra', bold: true },
        { text: compra.toFixed(2), alignment: 'right' },
        { text: 'Lucro', bold: true, color: lucro < 0 ? 'red' : 'green' },
        { text: lucro.toFixed(2), alignment: 'right', color: lucro < 0 ? 'red' : 'green' },
        { text: '' }
      ]);

      body.push([{ text: ' ', colSpan: 9 }, {}, {}, {}, {}, {}, {}, {}, {}]);
    });

    // 🔹 Resumo do cupom dentro do bloco
    body.push([
      { text: 'Resumo do Cupom', style: 'resumoTitulo', colSpan: 9 }, {}, {}, {}, {}, {}, {}, {}, {}
    ]);

    body.push([
      { text: `Venda: R$ ${vendaData.totalVenda.toFixed(2)}`, colSpan: 2 }, {},
      { text: `Desconto: R$ ${vendaData.totalDesconto.toFixed(2)}`, colSpan: 2 }, {},
      { text: `Compra: R$ ${vendaData.totalCompra.toFixed(2)}`, colSpan: 2 }, {},
      {
        text: `Lucro: R$ ${vendaData.totalLucro.toFixed(2)}`,
        colSpan: 3,
        color: vendaData.totalLucro < 0 ? 'red' : 'green',
        bold: true,
        alignment: 'center'
      }, {}, {}
    ]);

    docDefinition.content.push(
      {
        columns: [
          { text: `Caixa: ${vendaData.caixa}`, style: 'blockHeader', width: '25%' },
          { text: `Venda: ${vendaData.venda}`, style: 'blockHeader', width: '25%' },
          { text: `Numccf: ${vendaData.numccf}`, style: 'blockHeader', width: '25%' },
          { text: `Data: ${vendaData.data}`, style: 'blockHeader', width: '25%' }
        ]
      },
      {
        table: {
          widths: [40, 70, 40, 40, 40, 40, 45, 45, 55],
          body
        },
        layout: 'lightHorizontalLines',
        style: 'tableBody',
        margin: [0, 0, 0, 15]
      }
    );
  });

  // 🔹 Resumo geral organizado
  docDefinition.content.push({
    table: {
      widths: ['25%', '25%', '25%', '25%'],
      body: [[
        { text: `Total Vendas\nR$ ${totalVendaGeral.toFixed(2)}`, style: 'summary' },
        { text: `Total Descontos\nR$ ${totalDescontoGeral.toFixed(2)}`, style: 'summary' },
        { text: `Total Compra\nR$ ${totalCompraGeral.toFixed(2)}`, style: 'summary' },
        {
          text: `Lucro Geral\nR$ ${totalLucroGeral.toFixed(2)}`,
          style: 'summary',
          color: totalLucroGeral < 0 ? 'red' : 'green'
        }
      ]]
    },
    layout: 'lightHorizontalLines',
    margin: [0, 20, 0, 0]
  });

  docDefinition.footer = (currentPage, pageCount) => ({
    text: `${currentPage} / ${pageCount}`,
    alignment: 'right',
    fontSize: 9,
    margin: [0, 10, 20, 0]
  });

  pdfMake.createPdf(docDefinition).open();
}

export default VendasPorCupom;
